(function (ws) {
    'use strict';

    ws.views.financialServices = Backbone.View.extend({

        events: {
            'change #oligorList, #financeTermList, #repaymentFrequencyList, #renewalsExecutiveUID, #currencyDropdown, #hardware, #software, #vendorSupport, #total': 'validateData',
            'click #calculate': 'submitForm',
            'change #currencyDropdown': 'changeCurrency'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$('select').select2({
                minimumResultsForSearch: Infinity,
                dropdownAutoWidth: true,
                dropdownCssClass: 'comp-order-table'
            });
            this.fxRateValue = 0;
        },

        submitForm: function (e) {
            e.preventDefault();
            var form = $('.inputForm');
            this.model = new ws.models.financialServicesModel();
            let data = form.serializeArray();
            var dataObject = {};

            $.each(data, function() {
                if (dataObject[this.name] !== undefined) {
                    if (!dataObject[this.name].push) {
                        dataObject[this.name] = [dataObject[this.name]];
                    }

                    dataObject[this.name].push(this.value || '');
                } else {
                    dataObject[this.name] = this.value || '';
                }
            });

            this.model.set(dataObject);
            this.model.save(null, {silent: true, type: 'POST'}).done((response) => {
                this.eventAgg.trigger('financialServicesModal');
                $('.regular-repayment p:nth-child(2)').html(response.regularRepaymentAmount);
                $('.total-repayment p:nth-child(2)').html(response.totalRepaymentAmount);
                $('.server-error p').attr('hidden', 'true');
            }).fail(function () {
                $('.server-error p').removeAttr('hidden', 'true');
            });
        },

        validateData: function (e) {
            let editedField = e.currentTarget.id;
            let editedValue = e.currentTarget.value;
            let errorClassName = {hardware: 'hardware-error', software:'software-error', vendorSupport:'vendorSupport-error'};
            if (editedField in errorClassName) {
                let highlight = false;

                if (isNaN(editedValue) || Number(editedValue) < 0) {
                    $(`.${errorClassName[editedField]} span`).html('Pease enter a valid price');
                    highlight = true;
                } else if (editedValue.split('.')[1] && editedValue.split('.')[1].length > 2) {
                    $(`.${errorClassName[editedField]} span`).html('Please enter a price with 2 decimal points');
                    highlight = true;
                }

                if (highlight) {
                    $(`#${editedField}`).addClass('highlight');
                    $(`.${errorClassName[editedField]}`).removeClass('hide');
                    $('#total').val('');
                } else {
                    $(`#${editedField}`).removeClass('highlight');
                    $(`.${errorClassName[editedField]}`).addClass('hide');
                    this.calculateTotal();
                }

                if (this.fxRateValue < 50000 && !highlight) {
                    $(`.total-error span`).html('Please enter a price greater than 50K EUR');
                    $('#total').addClass('highlight');
                    $('.total-error').removeClass('hide');
                } else {
                    $(`.total-error span`).html('Please enter a price greater than 50K EUR');
                    $('#total').removeClass('highlight');
                    $('.total-error').addClass('hide');
                }
            }

            this.enableCalculateButton();
        },

        changeCurrency: function () {
            this.calculateTotal();
            this.enableCalculateButton();
        },

        calculateTotal: function () {
            let fields = ['hardware', 'software', 'vendorSupport'];
            let totalVal = 0;
            fields.forEach((id) => {
                totalVal += Number($(`#${id}`).val());
            });

            var currencySelected = $('#currencyDropdown').val();
            if (currencySelected !== '') {
                let currencyValue = 0;
                let fxRates = $('.fxRates').html().replace('{', '').replace('}', '').replace(/ /g, '').split(',');
                fxRates.forEach((currency) => {
                    if (currency.split('=')[0] === currencySelected) {
                        currencyValue = currency.split('=')[1];
                    }
                });

                this.fxRateValue = totalVal * currencyValue;
            }

            $('#total').val(totalVal);

            if (this.fxRateValue < 50000) {
                $(`.total-error span`).html('Please enter a price greater than 50K EUR');
                $('#total').addClass('highlight');
                $('.total-error').removeClass('hide');
            } else {
                $('#total').removeClass('highlight');
                $('.total-error').addClass('hide');
            }
        },

        enableCalculateButton: function () {
            let allDropdownsSelected = true;
            let inputFieldFilled = false;
            $('.financial-service-form select').each(function () {
                if (allDropdownsSelected) {
                    allDropdownsSelected = $(this).val() ? ($(this).val().length < 1 ? false : true) : false;
                }
            });

            $('.financial-service-form input').each(function () {
                if ($(this).attr('name') !== undefined && !inputFieldFilled && $(this).attr('name') !== 'totalFinancedAmount') {
                    inputFieldFilled = $(this).val() ? ($(this).val().length < 1 ? false : true) : false;
                }
            });

            if (allDropdownsSelected && inputFieldFilled && !$('.financial-service-inputs').find('*').hasClass('highlight')) {
                $('#calculate').removeAttr('disabled');
            } else {
                $('#calculate').attr('disabled', 'true');
            }
        }
    });
})(westcon);
